export type WhatsappBookingParams = {
  name?: string;
  service?: string;
  preferredDate?: string;
  preferredTime?: string;
  message?: string;
  emergency?: boolean;
  context?: string; // e.g., page/section context like "Corporate Wellness"
};

export function buildWhatsappLink(params: WhatsappBookingParams = {}): string {
  const {
    name,
    service,
    preferredDate,
    preferredTime,
    message,
    emergency,
    context,
  } = params;

  const safeName = (name || '').trim();
  const safeService = (service || '').trim();
  const safeDate = (preferredDate || '').trim();
  const safeTime = (preferredTime || '').trim();
  const safeMsg = (message || '').trim();
  const hdr = context ? `(${context})` : '';

  const parts: string[] = [];
  parts.push(`Hello Arpan PhysioCure ${hdr}`.trim());
  parts.push("I'd like to book an appointment.");
  if (emergency) parts.push('(EMERGENCY)');
  if (safeName) parts.push(`Name: ${safeName}`);
  if (safeService) parts.push(`Service: ${safeService}`);
  if (safeDate) parts.push(`Preferred Date: ${safeDate}`);
  if (safeTime) parts.push(`Preferred Time: ${safeTime}`);
  if (safeMsg) parts.push(`Message: ${safeMsg}`);

  const text = parts.join('\n');
  return `https://wa.me/917974434671?text=${encodeURIComponent(text)}`;
}


